import { render } from "./localeSelector.vue?vue&type=template&id=1e235228&scoped=true"
import script from "./localeSelector.vue?vue&type=script&lang=js"
export * from "./localeSelector.vue?vue&type=script&lang=js"

import "./localeSelector.vue?vue&type=style&index=0&id=1e235228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e235228"]])

export default __exports__